export const RESET_BOARD = 'events/RESET_BOARD';

/**
 * @param board
 * @return {{type: string, payload: board}
 */
export const resetBoard = (board) => ({
  type: RESET_BOARD,
  payload: board,
});
